import React from 'react';
// Layouts
import { Dialog, DialogTitle, DialogContent } from 'layouts/Dialog';
// Components
import IMedia from 'models/Media';
// Utilities
import { mediasInfo } from 'utilities/utilities';

type Props = {
  open: boolean;
  onClose: () => void;
  media: IMedia | null;
}

const MediaPreviewDialog:React.FC<Props> = ({ open, onClose, media }) => {
  if (!media) return null;

  const mediaFormatLabel = media.format ? mediasInfo[media.format].label : '';
  const title = media.title || mediaFormatLabel;

  return (
    <Dialog size="lg" open={open} onClose={onClose}>
      <DialogTitle title={title} onClose={onClose} />
      <DialogContent>
        <div className="w-full h-full flex justify-center">
          {media.type === 'image' ? (
            <img className="h-full object-contain" src={media.href} alt="" />
          ) : (
            <video className="h-full object-contain" controls>
              <source src={media.href} type="video/mp4" />
            </video>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default MediaPreviewDialog;
